import useSubState from '@/composables/use-sub-state';
import {
    fetchAdditionalProducts,
    fetchBasicProducts,
    fetchDentalProducts,
    fetchExcesses
} from '@/services/product';
import type { FetchExcessesData, ProductsResponse } from '@/types/product';
import { defineStore } from 'pinia';

const useProductStore = defineStore(
    'product',
    () => {
        const [basicProducts, getBasicProducts, clearBasisProducts] =
            useSubState<ProductsResponse>(fetchBasicProducts);
        const [additionalProducts, getAdditionalProducts, clearAdditionalProducts] =
            useSubState<ProductsResponse>(fetchAdditionalProducts);
        const [dentalProducts, getDentalProducts, clearDentalProducts] =
            useSubState<ProductsResponse>(fetchDentalProducts);
        const [excesses, getExcesses, clearExcesses] =
            useSubState<FetchExcessesData>(fetchExcesses);
        const clearStore = () => {
            clearBasisProducts();
            clearDentalProducts();
            clearAdditionalProducts();
            clearExcesses();
        };

        return {
            basicProducts,
            getBasicProducts,
            clearBasisProducts,
            additionalProducts,
            getAdditionalProducts,
            clearAdditionalProducts,
            dentalProducts,
            getDentalProducts,
            clearDentalProducts,
            excesses,
            getExcesses,
            clearExcesses,
            clearStore
        };
    },
    {
        persist: {
            pick: [
                'basicProducts.data',
                'additionalProducts.data',
                'dentalProducts.data',
                'excesses.data'
            ]
        }
    }
);

export default useProductStore;
